import { PlaycastNameValuePair } from '@playcastdotio/CoreTypes';

let inputTimestamp = 0;
let messageTimestamp = 0;

export { inputTimestamp, messageTimestamp };

export const captureInputTimestamp = (): void => {
  inputTimestamp = performance.now();
};

export const captureMessageTimestamp = (): void => {
  messageTimestamp = performance.now();
};

export const getInputToMessageLatency = (): number => {
  if (inputTimestamp === 0 || messageTimestamp === 0) {
    return 0;
  }
  return messageTimestamp - inputTimestamp;
};

export const getTimingData = (): PlaycastNameValuePair[] => {
  const timings: PlaycastNameValuePair[] = [];

  if (inputTimestamp > 0) {
    timings.push({
      name: 'input_timestamp',
      value: inputTimestamp,
    });
  }

  if (messageTimestamp > 0) {
    timings.push({
      name: 'message_timestamp',
      value: messageTimestamp,
    });
  }

  const latency = getInputToMessageLatency();
  if (latency > 0) {
    timings.push({
      name: 'input_to_message_latency_ms',
      value: Math.round(latency * 100) / 100,
    });
  }

  return timings;
};

export const resetTiming = (): void => {
  inputTimestamp = 0;
  messageTimestamp = 0;
};
